import { css } from '@emotion/css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Colors } from '../../styles/colors';

const ROWS = 8;

export const HistoryLoadingState = (): JSX.Element => {
  return (
    <SkeletonTheme baseColor={Colors.SURFACE} highlightColor="#e6ecf1">
      <div aria-busy="true" aria-label="Loading history">
        {Array.from({ length: ROWS }).map((_, index) => (
          <div key={index}>
            <div className={rowStyle}>
              <div className={rowLineStyle}>
                <Skeleton height={'1.125rem'} width={'40%'} borderRadius={6} />
                <Skeleton height={'1.125rem'} width={'25%'} borderRadius={6} />
              </div>
              <div className={rowLineStyle}>
                <Skeleton height={'1rem'} width={'55%'} borderRadius={6} />
                <Skeleton height={'1rem'} width={'18%'} borderRadius={6} />
              </div>
            </div>
            <Skeleton height={'1px'} borderRadius={0} />
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

const rowStyle = css`
  padding: 0.875rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const rowLineStyle = css`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  > span {
    display: block;
  }
`;
